/* eslint-disable no-unused-vars */
/* eslint-disable react/style-prop-object */
import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

class MyCard extends React.Component {
    constructor(param) {
      super(param)
      this.state={
          datos:[]
      }
      this.getDetalle.bind(this);      
      this.setState({datos:this.props.value})
    //   style={{maxWidth: 38+'rem'}}
    //
    }

    getDetalle=(xreg)=>{        
        let card1 = xreg.map(registro=>{
            let header1 = <></>;
            let body1   = <></>;
            let row1    = <></>;
            let row2    = <></>;
            let card2   = <></>;

            if (registro.estado==="APROBADO") {
                header1 = "card-header bg-success"
                body1   ="card-body bg-dark"
                row1    ="list-group-item bg-secondary"
                row2    = "list-group-item bg-dark"
                card2   = "card bg-info mb-3 text-white"
            }
            if (registro.estado!=="APROBADO" && registro.estado!=="PENDIENTE DE PROTESTA") {
                header1 = "card-header bg-danger blink-danger"
                body1   = "card-body bg-danger"
                card2   = "card bg-danger mb-3 text-white"
            }
            if (registro.estado==="PENDIENTE DE PROTESTA") {
                header1 = "card-header bg-warning text-dark blink-warning"
                body1   = "card-body bg-warning text-dark"
                row1    ="list-group-item bg-secondary text-white"
                row2    = "list-group-item bg-dark text-white"
                card2   = "card bg-warning mb-3 text-gray"
            }
            
            return (
                <>
                <div style={{margin:0+' Auto',maxWidth: 35+'rem'}} className={card2}>
                    <div className={header1}>{registro.estado+'    ['+registro.tipo_inscrito+']' }</div>
                    <div className={body1} >
                        <h5 className="card-title">{registro.estado} n&uacute;mero de inscripci&oacute;n: {registro.autorizado}</h5>
                        <p className="card-text">
                            <ul className="list-group list-group-flush">
                                <li className={row1}>Aprobado: {registro.aprobado}</li>
                                <li className={row2}>Nombre: {registro.completo}</li>
                                <li className={row1}>Vencimiento: {registro.vencimiento} </li>
                                <li className={row2}>comentario: {registro.comentario}</li>
                            </ul>                                      
                        </p>
                    </div>
                    </div>
               
                </>
            )
            });
            return card1;
    }

    render(){        
       return (
           <>
           {this.getDetalle(this.props.value)}
           </>
       )
    }
  }
  export default MyCard;